/* @flow */
import { getterFromKeyPath } from 'trustar/utils';
import { Map, List } from 'immutable';

export const malwareTerms = getterFromKeyPath(['malware', 'terms']);
export const loading = getterFromKeyPath(['malware', 'loading']);
export const modalOpen = getterFromKeyPath(['malware', 'modalOpen']);
export const currentQuery = getterFromKeyPath(['malware', 'currentQuery']);

export const defaultSorterValues = {
  searchSorterPlaceholder: 'Select',
  searchSorters: Map({
    text: 'Newest to Oldest Updated',
    sort: {
      sortBy: 'updated',
      sortDirection: 'DESC', // ASC / DESC
    }
  })
};

export const sortOptions = [
  {
    text: 'Newest to Oldest Updated',
    sort: {
      sortBy: 'updated',
      sortDirection: 'DESC'
    }
  },
  {
    text: 'Oldest to Newest Updated',
    sort: {
      sortBy: 'updated',
      sortDirection: 'ASC'
    }
  },
  {
    text: 'Newest to Oldest Created',
    sort: {
      sortBy: 'created',
      sortDirection: 'DESC'
    }
  },
  {
    text: 'Oldest to Newest Created',
    sort: {
      sortBy: 'created',
      sortDirection: 'ASC'
    }
  }
];

export const defaultPayload =
  Map({
    query: '',
    sort: defaultSorterValues.searchSorters,
    pageNumber: 0,
    pageSize: 25,
  });

export const defaultResult = Map({
  empty: true,
  items: List(), // PAGE SIZE and stuff? TODO
});



// WEBPACK FOOTER //
// ./src/app/modules/malware/getters.js